import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserCircle } from 'lucide-react';
import Notification from '../Notification/Notification';
import logo from '../../assets/images/Logo.png';
import './topnavBar.css';
import ChangePassword from '../change-password/ChangePassword';
import AdminNotificationTopBell from '../admin/Notification/AdminNotificationTopBell';
import ClientNotificationTopBell from '../ClientModule/ClientNotificationTopBell';
import CandidateNotificationTopBell from '../candidate/CandidateDashboard/candidatenotificaion/CandidateNotificationTopBell';
import EmployeeNotificationTopBell from '../employee/NotificationBell/EmployeeNotificationTopBell';

const TopNavbar = ({ showNotification = true, notificationConfig }) => {
  const [userEmail, setUserEmail] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const dropdownRef = useRef(null);
  const userRole = localStorage.getItem("user_role");

  const navigate = useNavigate();

  useEffect(() => {
    const email = localStorage.getItem('user_name');
    if (email) setUserEmail(email);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    if (showDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showDropdown]);

  const handleLogout = () => {
    localStorage.setItem(
      "logoutEvent",
      Date.now().toString()
    );
    localStorage.removeItem("bgc_token");
    localStorage.removeItem("bgc_refresh_token");
    localStorage.removeItem("user_email");
    localStorage.removeItem("user_role");
    localStorage.removeItem("user_name");
    navigate('/');
  };

  const handleChangePassword = () => {
    setShowDropdown(false);
    setShowChangePassword(true);
  };

  return (
    <>
      <header className="admin-dashboard-header">
        <div className="top-logo-wrapper">
          <div className="top-logo-container">
            <img src={logo} alt="Company Logo" className="logo-image" />
          </div>
        </div>

        <div className="admin-top-right-icons" ref={dropdownRef}>

          {showNotification && (
            <>
              {userRole === "ADMIN" && <AdminNotificationTopBell />}

              {userRole === "USER" && <ClientNotificationTopBell />}

              {userRole === "CANDIDATE" && <CandidateNotificationTopBell />}

              {userRole === "EMPLOYEE" && <EmployeeNotificationTopBell />}

            </>
          )}

          <span className="admin-candidate-name">{userEmail}</span>


          <UserCircle
            className="admin-icon"
            onClick={() => setShowDropdown(!showDropdown)}
          />

          {showDropdown && (
            <div className="admin-dropdown-menu">
              <ul>
                <li onClick={handleChangePassword}>Change Password</li>
                <li onClick={handleLogout}>Logout</li>
              </ul>
            </div>
          )}
        </div>
      </header>

      {showChangePassword && (
        <ChangePassword onClose={() => setShowChangePassword(false)} />
      )}
    </>
  );
};

export default TopNavbar;